import HistoryDrawer from './components/HistoryDrawer';
import RequiredModal from './components/RequiredModal';
import { Button, Space, Table, Tag, Tooltip } from 'antd';
import { EditOutlined, HistoryOutlined } from '@ant-design/icons';
import { IDocumentTemplate } from 'interfaces/documentation/document-template';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { TextField, useTable } from '@refinedev/antd';
import { useCan, useModal } from '@refinedev/core';
import { useState } from 'react';

// O resource do refine (`document_templates`) existe para permissão; o caminho real da API é
// outro, então as chamadas de dado passam o resource explícito, como as demais telas de documentos.
const API_RESOURCE = 'documents/templates';

const categoryMAP = {
  identification: 'Documento de identificação',
  academic: 'Documento academico',
  supplementary: 'Documento complementar'
};

export const DocumentTemplatesList = () => {
  const [templateContext, setTemplateContext] = useState<IDocumentTemplate>();
  const [historyTemplate, setHistoryTemplate] = useState<IDocumentTemplate>();
  const modal = useModal();

  const { tableProps } = useTable<IDocumentTemplate>({
    resource: API_RESOURCE
  });

  const { data: canEdit } = useCan({
    resource: 'document_templates',
    action: 'edit'
  });

  return (
    <ListLayout title="Templates de Documentos">
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="category"
          key="category"
          title="Categoria"
          render={(value: keyof typeof categoryMAP) => (
            <TextField value={categoryMAP[value] ?? value} />
          )}
        />
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome do documento"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="required"
          key="required"
          title="Obrigatoriedade"
          render={(value: boolean) => (
            <TextField value={value ? 'Obrigatório' : 'Opcional'} />
          )}
        />
        <Table.Column
          dataIndex="required_courses_count"
          key="required_courses_count"
          title="Exigido por curso"
          render={(value: number) =>
            value > 0 ? (
              <Tooltip title="Exigem por conta própria; este flag não os afeta">
                <Tag color="warning">
                  {value} {value === 1 ? 'curso' : 'cursos'}
                </Tag>
              </Tooltip>
            ) : (
              <TextField value="—" />
            )
          }
        />
        <Table.Column<IDocumentTemplate>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => (
            <Space>
              {canEdit?.can && (
                <Tooltip title="Editar obrigatoriedade">
                  <Button
                    icon={<EditOutlined />}
                    size="small"
                    onClick={() => {
                      setTemplateContext(record);
                      modal.show();
                    }}
                  />
                </Tooltip>
              )}
              <Tooltip title="Histórico de alterações">
                <Button
                  icon={<HistoryOutlined />}
                  size="small"
                  onClick={() => setHistoryTemplate(record)}
                />
              </Tooltip>
            </Space>
          )}
        />
      </Table>

      {canEdit?.can && (
        <RequiredModal
          modal={modal}
          template={templateContext}
          resource={API_RESOURCE}
        />
      )}

      <HistoryDrawer
        template={historyTemplate}
        open={Boolean(historyTemplate)}
        onClose={() => setHistoryTemplate()}
      />
    </ListLayout>
  );
};
